const CORPORATE = "https://quantarock.in";

// Interseller's navigation is deliberately short: this site sells hardware.
// Company, services, careers and the blog belong to quantarock.in, which links
// here via its "Visit Shop" action — the header's corporate link points back.
// `external: true` items leave the site and render as real anchors.
export const Header_Menu_Items = [
  { title: "Home", pageId: "/" },
  { title: "Products", pageId: "/all-products" },
  { title: "Certifications", pageId: "/certifications" },
  { title: "Contact Us", pageId: `${CORPORATE}/contact`, external: true },
];

// The tools suite is its own subdomain, not a route on either site.
export const TOOLS_SITE = {
  label: "Tools",
  url: "https://tools.quantarock.in",
};

export const CORPORATE_SITE = {
  label: "QuantaRock",
  url: CORPORATE,
  // The header's QuantaRock button lands on the corporate homepage, not a
  // single service page — visitors pick their own destination from there.
  servicesUrl: CORPORATE,
};
